import { Asterisk } from "lucide-react";

const WORDS = ["Strategy", "Content", "SEO", "Social", "Email", "Paid", "Less noise", "More signal", "Made in Canberra"];

export const Marquee = () => {
  const row = WORDS.flatMap((w, i) => [
    <span key={`w${i}`} className={`font-display text-5xl font-bold tracking-tight sm:text-7xl lg:text-8xl ${i % 2 ? "text-ink/25" : "text-ink"}`}>
      {w}
    </span>,
    <Asterisk key={`a${i}`} className="h-10 w-10 shrink-0 text-flame sm:h-14 sm:w-14" strokeWidth={2.5} />,
  ]);
  return (
    <section aria-label="What we do" className="marquee overflow-hidden border-y border-ink/10 py-8 sm:py-10" data-testid="editorial-marquee">
      <div className="marquee-track flex w-max items-center gap-8 sm:gap-12">
        <div className="flex items-center gap-8 sm:gap-12">{row}</div>
        <div className="flex items-center gap-8 sm:gap-12" aria-hidden="true">{row}</div>
      </div>
    </section>
  );
};
